<template>
    <!--
    	作者：bbc_team
    	时间：2023-06-08
    	描述：商品管理-商品编辑-规格/库存-单规格
    -->
    <div>
        <el-form-item label="产品编码：" :rules="[{ required: true, message: '请填写产品编码' }]" prop="model.sku.goods_no">
            <el-input v-model="form.model.sku.goods_no" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="产品价格：" width="80" :rules="[{ required: true, message: '请填写产品价格' }]" prop="model.sku.goods_price">
            <el-input v-model="form.model.sku.goods_price" type="number" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="产品划线价：" :rules="[{ required: true, message: '请填写产品划线价' }]" prop="model.sku.line_price">
            <el-input v-model="form.model.sku.line_price" type="number" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="库存数量：" :rules="[{ required: true, message: '请填写库存数量' }]" prop="model.sku.stock_num">
            <el-input v-model="form.model.sku.stock_num" type="number" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="商品重量(Kg)：" :rules="[{ required: true, message: '请填写商品重量' }]" prop="model.sku.goods_weight">
            <el-input v-model="form.model.sku.goods_weight" type="number" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="村赞币价格：" prop="model.sku.cunzan_coin">
            <el-input v-model="form.model.sku.cunzan_coin" type="number" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="结算价格：" prop="model.sku.settlement_price">
            <el-input v-model="form.model.sku.settlement_price" type="number" class="max-w460"></el-input>
        </el-form-item>
    </div>
</template>

<script>
    export default {
        inject: ["form"]
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/goods/goods/part/spec/Single.vue